import { render, staticRenderFns } from "./photoGalleryIndex.vue?vue&type=template&id=d65b5f4c&"
import script from "./photoGalleryIndex.vue?vue&type=script&lang=js&"
export * from "./photoGalleryIndex.vue?vue&type=script&lang=js&"
import style0 from "./photoGalleryIndex.vue?vue&type=style&index=0&id=d65b5f4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports